import { atom } from "recoil";

export const currentLectureType = atom({
  key: "currentLectureType",
  default: "",
});

export const currentLectureCategory = atom({
  key: "currentLectureCategory",
  default: "",
});
